import { ReactElement, useEffect, useMemo, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { QueryFunctionContext, useInfiniteQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { isLoadingState } from '@/recoil';
import ErrorPartial from '@/containers/common/error/Partial';

export default function useInfiniteQueryHook(
    key: (string | number | undefined)[],
    // fetch: (_props: QueryFunctionContext) => Promise<{ page: number }>,
    fetch: (_props: QueryFunctionContext) => Promise<any>,
    options?: UseQueryOptions<any, AxiosError, any, (string | number | undefined)[]>, // TODO 타입 다시 확인
) {
    const {
        data,
        isError,
        isSuccess: _isSuccess,
        fetchNextPage,
        isFetching,
        refetch,
        hasNextPage,
        ...result
    } = useInfiniteQuery(key, fetch, {
        getNextPageParam: lastPage => {
            const nextPage = lastPage.metadata.page + 1;
            const totalPage = Math.ceil(lastPage.metadata.totalCount / lastPage.metadata.pageSize);
            return nextPage > totalPage ? undefined : nextPage;
        },
        keepPreviousData: true,
        onSettled: () => setLoading(false),
        ...options,
    });
    const [RenderError, setRenderError] = useState<ReactElement | undefined>(undefined);
    const [isSuccess, setIsSuccess] = useState(false);
    const setLoading = useSetRecoilState(isLoadingState);
    const contents = useMemo(() => {
        if (data) {
            return data?.pages.flatMap(contents => contents.data);
        }
        return [];
    }, [data]);

    useEffect(() => {
        if (data === undefined) setLoading(isFetching);
    }, [isFetching]);

    useEffect(() => {
        // api 통신 성공한 경우
        if (_isSuccess) {
            // data가 null이 온 경우 (서버에서 null은 무조건 에러인 것을 보장함)
            if (data === null) {
                setRenderError(<ErrorPartial type="access" />);
                setIsSuccess(false);
                return;
            }
            setIsSuccess(true);
        } else {
            // api 통신 실패한 경우
            if (isError) {
                setRenderError(<ErrorPartial type="communication" />);
                setIsSuccess(false);
                return;
            }
        }
        // renderError 초기화
        setRenderError(undefined);
    }, [data, isError, _isSuccess]);

    return { data: contents, isSuccess, isFetching, RenderError, fetchNextPage, refetch, result, hasNextPage, isError };
}
